<template>
  <div class="variant-selector">
    <a
      v-for="variant in sortedVariants"
      :key="variant.id"
      class="variant-selector__variant"
      :class="{
        'variant-selector__variant--selected': variant.id === currentVariant.id,
        'variant-selector__variant--hidden':
          variant.gender !== selectedGender && selectedGender !== GENDERS.unisex,
      }"
      @click="selectVariant($event, variant)"
      v-data-test-id="'variant-selector-variant'"
    >
      <div
        v-if="variant.labels.includes(BADGES.newColor.type)"
        class="variant-selector__new-color"
      ></div>
      <ImageContentful
        :src="variant.defaultImageSmall.mediaUrl || ''"
        containerSelector=".variant-selector__variant"
        :options="{ setHeight: false }"
        class="variant-selector__image"
      />
    </a>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex'
import { BADGES } from '@/config/constants'
import { GENDERS } from '@/stores/product'
import ImageContentful from '@/components/_shared/ImageContentful.vue'
import { sortVariantsByStock } from '@/components/FilterPage/transformation-helpers.js'

export default {
  name: 'VariantSelector',
  components: { ImageContentful },
  data() {
    return {
      isSelected: false,
      GENDERS,
      BADGES,
      sortedVariants: [],
    }
  },

  computed: {
    ...mapState('product', ['selectedGender', 'isRouteUpdatingBlocked']),

    ...mapGetters({
      isMqLarge: 'viewport/isMqLarge',
      product: 'product/product',
      currentVariant: 'product/currentVariant',
    }),
  },

  mounted() {
    this.sortItems()
  },

  methods: {
    ...mapMutations({
      setCurrentVariantId: 'product/setCurrentVariantId',
      resetSlideIndex: 'product/resetSlideIndex',
    }),

    ...mapActions({
      replaceRoute: 'product/replaceRoute',
    }),

    selectVariant($event, variant) {
      this.setCurrentVariantId(variant.id)
      this.resetSlideIndex()
      if (!this.isRouteUpdatingBlocked) this.replaceRoute()
      this.$emit('select-variant')
      this.$notifier.trackEvent({
        action: this.$notifier.ACTIONS.productInteraction,
        details: {
          action: 'color_select',
          label: `${this.product.name} || ${variant.color}`,
        },
      })
    },

    sortItems() {
      this.sortedVariants = sortVariantsByStock(this.product.variants)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './VariantSelector';
</style>
